import { Pipe, PipeTransform } from '@angular/core';
import { appUnbox } from '@macs-frontend/core/utils/ngrx-forms';
import { InvoiceItem } from '@macs-frontend/features/shared/models/invoice-item.model';

@Pipe({ name: 'invoiceItemQuantity', pure: true })
export class InvoiceItemQuantityPipe implements PipeTransform {
  public transform(invoiceItem: InvoiceItem, qtyPosition: '1' | '2'): string {
    const quantity = invoiceItem[qtyPosition === '1' ? 'qty1' : 'qty2'];
    const type = appUnbox(invoiceItem[qtyPosition === '1' ? 'qty1Type' : 'qty2Type']);

    if (type?.name === 'Blank') {
      return '';
    }

    const typeSign = type?.name === 'Percentage' ? '%' : type?.name;

    return (quantity || 0) + ' ' + (typeSign || '');
  }
}
